import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { DataTable } from "../../utils/data_table";

export const AdminBoards: React.FC = () => {
  const tableRef = useRef<any>(null);

  return (
    <div>
      <Link to="/admin" className="flex items-center gap-2 mb-6">
        ← Admin
      </Link>
      <h1 className="text-2xl font-bold mb-6">Boards</h1>

      <DataTable
        ref={tableRef}
        url="/api/admin/boards"
        columns={[{ key: "name" }, { key: "user.name", header: "User" }]}
      />
    </div>
  );
};
